/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore, slugCreator } from '../../core/useStore';
import { SVBFAQSearchBar } from '@svb/portal-ui-react-components/dist/react-molecule/SVBSearch';
import {
  SVBFaqMostCommonResult,
  SVBFaqSearchEmptyResult,
  SVBFaqAllResult,
  SVBFaqFilter,
} from './helpers';
import Loading from '@svb/api-loading-component/dist/components/index';
import searchMockService from './helpers/service';
import { SVBTypography, SVBBreadCrumb, SVBButton } from '@svb/svb-react-components';
import { Link } from 'react-router-dom';
import questionIcon from '@svb/svbbranding/dist/assets/icons/question-circle-white.svg';
import topIcon from '@svb/svbbranding/dist/assets/icons/arrow-top-white.svg';
export default function FAQLandingPage(props) {
  const { dataTestId, mockData, filterFrom } = props;
  const [loading, setLoading] = useState(true);
  const [searchData, setSearchData] = useState([]);
  const [searchTerm, setsearchTerm] = useState([]);
  const [submittedTerm, setsubmittedTerm] = useState('');
  const [submit, setSubmit] = useState(false);
  const [results, setresults] = useState([]);
  const [resultsCount, setresultsCount] = useState(0);
  const [viewAllBtn, setViewAllBtn] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [filterKeys, setFilterKeys] = useState([]);
  const [filterCount, setFilterCount] = useState(false);
  const [filterArray, setFilterArray] = useState([]);
  const [inputChangeVal, setinputChangeVal] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [activeId, setActiveId] = useState('');
  const Heading_Faqs = 'How can we help?';
  const FaqsItemsData = dataTestId ? mockData : useStore((state) => state.faqsItems);
  const filterTopics = [];
  const onsearchTermChange = async (e, filterValue = '') => {
    setActiveId('');
    if (filterValue) {
      setsearchTerm(filterValue);
      setinputChangeVal(filterValue);
      setsubmittedTerm(filterValue);
    } else {
      setsearchTerm(e.target.value);
      setinputChangeVal(e.target.value);
      setsubmittedTerm(e.target.value);
    }
    setFilterCount(false);
    setViewAllBtn(true);
    setSubmit(true);
    // setsubmittedTerm(searchTerm);
    setresults([]);
    setresultsCount(0);
    let optionsSet = false;
    let testingSet = false;
    await searchMockService(
      (e && e.target.value) || filterValue,
      optionsSet,
      testingSet,
      FaqsItemsData,
    )
      .then(
        (x) => {
          let results = x;
          if (results.length > 0) {
            setresults(results);
            setLoading(false);
            setresultsCount(results.length);
          } else {
            const resMessage =
              (results.response && results.response.data && results.response.data.message) ||
              results.message ||
              results.toString();
            console.log(resMessage);
            setLoading(false);
          }
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();
          console.log(resMessage);
        },
      )
      .catch((err) => console.log(err));
    return;
  };
  const onViewAllClick = () => {
    setFilterCount(false);
    setViewAllBtn(true);
  };
  const handleSubmit = async () => {
    setViewAllBtn(true);
    setSubmit(true);
    setsubmittedTerm(searchTerm);
    setresults([]);
    setresultsCount(0);
    let optionsSet = false;
    let testingSet = false;
    await searchMockService(searchTerm, optionsSet, testingSet, searchData)
      .then(
        (x) => {
          let results = x;
          if (results.length > 0) {
            setresults(results);
            setLoading(false);
            setresultsCount(results.length);
          } else {
            const resMessage =
              (results.response && results.response.data && results.response.data.message) ||
              results.message ||
              results.toString();
            console.log(resMessage);
            setLoading(false);
          }
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();
          console.log(resMessage);
        },
      )
      .catch((err) => console.log(err));
    return;
  };
  //  create CardJson array for Search Result comp
  let arrangeCardJson = [];
  if (submit && resultsCount > 0) {
    results.map((resultItem) => {
      arrangeCardJson.push({
        title: resultItem.title,
        description: resultItem.description,
        tags: resultItem.tags,
      });
    });
  }
  const onFilterFunc = (value) => {
    setActiveId(value.id);
    let filterArrayVal = [];
    searchData.map((faqData) => {
      const filterData = faqData?.topics?.find((item) => item === value.label);
      if (filterData) {
        filterArrayVal.push({
          title: faqData.title,
          description: faqData.description,
          tags: faqData.tags,
        });
      }
    });
    setFilterArray(filterArrayVal);
    setFilterKeys(value.label);
    setFilterCount(true);
    setViewAllBtn(true);
  };
  //@todo
  useEffect(() => {
    if (filterFrom) {
      setinputChangeVal(filterFrom);
      onsearchTermChange('', filterFrom);
    }

    FaqsItemsData.map((item) => {
      filterTopics.push(item.topics.toString());
    });
    const filterString = [...new Set(filterTopics)].toString();
    const filteredAttay = filterString.split(',').filter(function (item, pos, self) {
      return self.indexOf(item) == pos;
    });
    const systemTopics = [];
    const apiTopics = [];
    filteredAttay.map((item) => {
      item === 'General' || item === 'Security and Compliance' || item === 'Testing'
        ? systemTopics.push(item)
        : apiTopics.push(item);
    });
    const sortedFilteredArray = [...systemTopics.sort(), ...apiTopics.sort()];
    setSearchData(FaqsItemsData);
    let filterdataArray = [];
    sortedFilteredArray.map((item, id) => {
      filterdataArray.push({ label: item, id: id });
    });
    setFilterData(filterdataArray);
    setLoading(false);
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className='pt-4'>
            <SVBBreadCrumb
              breadCrumbs={[
                { breadCrumb: 'Home', link: '/', dataTestId: 'breadcrumb-faq-home' },
                { breadCrumb: 'Faqs', link: '#', dataTestId: 'breadcrumb-faq-faqs' },
              ]}
              extraClasses
            ></SVBBreadCrumb>
          </div>
          <section id='Faq-resultSection' className='result-section'>
            <div className='container svb-container-fixed col-md-9 col-sm-12'>
              <div className='row pt-8'>
                <SVBTypography type='heading-xlarge'>{Heading_Faqs}</SVBTypography>
              </div>
              <div className='row'>
                <section className='col-md-9 col-sm-9'>
                  <div className='row'>
                    <form onSubmit={(e) => e.preventDefault()}>
                      <SVBFAQSearchBar
                        value={inputChangeVal}
                        setValue={setInputValue}
                        onsearchTermChange={onsearchTermChange}
                        handleSubmit={handleSubmit}
                        enableSubmit={searchTerm && true}
                        placeHolderData='Search in Support'
                      />
                    </form>
                    {filterCount ? (
                      <SVBFaqFilter
                        cardJson={searchData}
                        searchTerm={searchTerm}
                        filterKeys={filterKeys}
                        filterArray={filterArray}
                      />
                    ) : viewAllBtn ? (
                      submit ? (
                        resultsCount > 0 ? (
                          <SVBFaqAllResult cardJson={arrangeCardJson} searchTerm={searchTerm} />
                        ) : (
                          <SVBFaqSearchEmptyResult searchParam={submittedTerm} />
                        )
                      ) : (
                        searchData && (
                          <SVBFaqAllResult cardJson={searchData} searchTerm={searchTerm} />
                        )
                      )
                    ) : submit ? (
                      resultsCount > 0 ? (
                        <SVBFaqMostCommonResult cardJson={arrangeCardJson} />
                      ) : (
                        <SVBFaqSearchEmptyResult searchParam={submittedTerm} />
                      )
                    ) : (
                      searchData && <SVBFaqMostCommonResult cardJson={searchData} />
                    )}
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-sm-12'>
                      {!viewAllBtn ? (
                        <span onClick={onViewAllClick}>
                          <SVBTypography
                            type='paragraph'
                            variant='bold viewall-btn justify-content-end d-flex'
                          >
                            View All -&gt;{' '}
                          </SVBTypography>
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </section>
                <section className='col-md-3 col-sm-3'>
                  {/* <Link to='/contact'>
                    <button
                      type='button'
                      data-testid={'faq-contact-support'}
                      className='w-100 mt-3 rounded svb-button_large svb-button_primary-default py-2 px-3 h-auto'
                    >
                      <img key='icon-left' src={questionIcon} className='px-1' /> Contact Support
                    </button>
                  </Link> */}
                  <SVBButton
                    extraClasses='w-100 mt-3'
                    text='Contact Support'
                    size='large'
                    style='secondary'
                    state='default'
                    type='text'
                    icon='right-arrow'
                    iconSide='right'
                    onClick={() => (window.location.href = '/contact')}
                    data-testid={'faq-contact-support'}
                  />
                  <div className='mt-4 faq-filter-container p-3'>
                    {filterData?.map((item) => {
                      return (
                        <div
                          key={item.id}
                          data-testid={slugCreator('faq' + '-' + item.label + '-' + item.id)}
                          className='filter-topics-div'
                          onClick={() => onFilterFunc(item)}
                        >
                          {activeId === item.id ? (
                            <SVBTypography type='paragraph' variant='filter-topics-active'>
                              {item.label}
                            </SVBTypography>
                          ) : (
                            <SVBTypography type='paragraph' variant='filter-topics'>
                              {item.label}
                            </SVBTypography>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className='w-100 d-flex justify-content-end'>
                    <button
                      type='button'
                      data-testid={'faq-top-button'}
                      className='scroll-top-btn svb-button_small svb-button_primary-default py-2 px-3 h-auto'
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    >
                      <img key='icon-left' src={topIcon} /> Top
                    </button>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}
